import { call, put, takeLatest, all } from 'redux-saga/effects';
import {
    FETCH_DECISION_TABLE_NAMES_START,
    FetchDecisionTableNamesStartAction,
    fetchDecisionTableNamesSuccess,
    fetchDecisionTableNamesFailed,
    FETCH_DECISION_TABLE_CONFIG_START,
    FetchDecisionTableConfigStartAction,
    fetchDecisionTableConfigSuccess,
    fetchDecisionTableConfigFailed,
    SAVE_DECISION_TABLE_CONFIG_START,
    SaveDecisionTableConfigStartAction,
    saveDecisionTableConfigSuccess,
    saveDecisionTableConfigFailed,
    CREATE_DECISION_TABLE_CONFIG_START,
    CreateDecisionTableConfigStartAction,
    createDecisionTableConfigSuccess,
    createDecisionTableConfigFailed,
    DELETE_DECISION_TABLE_CONFIG_START,
    DeleteDecisionTableConfigStartAction,
    deleteDecisionTableConfigSuccess,
    deleteDecisionTableConfigFailed
} from "src/actions/DecisionTableConfigActions";
import DecisionTableConfigApiUtil from "src/utils/DecisionTableConfigApiUtil";

// Fetch Decision Table Names Saga
export function* fetchDecisionTableNames(action: FetchDecisionTableNamesStartAction) {
    try {
        // @ts-ignore
        const response = yield call(DecisionTableConfigApiUtil.getDecisionTableNames);
        yield put(fetchDecisionTableNamesSuccess(response));
    } catch (error) {
        console.error("Fetch Decision Table Names error:", error);
        yield put(fetchDecisionTableNamesFailed());
    }
}

// Fetch Fee Configuration Saga
export function* fetchDecisionTableConfig(action: FetchDecisionTableConfigStartAction) {
    try {
        console.log("Fetching fee configuration for:", action.decisionTableName);
        // @ts-ignore
        const response = yield call(DecisionTableConfigApiUtil.getDecisionTableConfig, action.decisionTableName);
        console.log("Fee configuration response:", response);
        if (response) {
            yield put(fetchDecisionTableConfigSuccess(response));
        } else {
            console.log("No configuration found for:", action.decisionTableName);
            yield put(fetchDecisionTableConfigFailed());
        }
    } catch (error) {
        console.error("Fetch Fee Configuration error:", error);
        yield put(fetchDecisionTableConfigFailed());
    }
}

// Save Fee Configuration Saga
export function* saveDecisionTableConfig(action: SaveDecisionTableConfigStartAction) {
    try {
        // @ts-ignore
        const response = yield call(DecisionTableConfigApiUtil.updateDecisionTableConfig, action.request);
        yield put(saveDecisionTableConfigSuccess(response));
    } catch (error) {
        console.error("Save Fee Configuration error:", error);
        const errorMessage = error instanceof Error ? error.message : "Failed to save configuration";
        yield put(saveDecisionTableConfigFailed(errorMessage));
    }
}

// Create Fee Configuration Saga
export function* createDecisionTableConfig(action: CreateDecisionTableConfigStartAction) {
    try {
        // @ts-ignore
        const response = yield call(DecisionTableConfigApiUtil.createDecisionTableConfig, action.request);
        yield put(createDecisionTableConfigSuccess(response));
        
        // Refresh the decision table names list after successful creation
        try {
            // @ts-ignore
            const keysResponse = yield call(DecisionTableConfigApiUtil.getDecisionTableNames);
            yield put(fetchDecisionTableNamesSuccess(keysResponse));
        } catch (keysError) {
            console.error("Failed to refresh decision table names after creation:", keysError);
            // Don't fail the entire operation if refreshing keys fails
        }
    } catch (error) {
        console.error("Create Fee Configuration error:", error);
        const errorMessage = error instanceof Error ? error.message : "Failed to create configuration";
        yield put(createDecisionTableConfigFailed(errorMessage));
    }
}

// Delete Fee Configuration Saga
export function* deleteDecisionTableConfig(action: DeleteDecisionTableConfigStartAction) {
    try {
        // @ts-ignore
        yield call(DecisionTableConfigApiUtil.deleteDecisionTableConfig, action.decisionTableName);
        yield put(deleteDecisionTableConfigSuccess());
        
        // Refresh the decision table names list after successful deletion
        try {
            // @ts-ignore
            const keysResponse = yield call(DecisionTableConfigApiUtil.getDecisionTableNames);
            yield put(fetchDecisionTableNamesSuccess(keysResponse));
        } catch (keysError) {
            console.error("Failed to refresh decision table names after deletion:", keysError);
            // Don't fail the entire operation if refreshing keys fails
        }
    } catch (error) {
        console.error("Delete Fee Configuration error:", error);
        const errorMessage = error instanceof Error ? error.message : "Failed to delete configuration";
        yield put(deleteDecisionTableConfigFailed(errorMessage));
    }
}

// Root Saga for Decision Table Names
export function* decisionTableNamesSaga() {
    yield takeLatest(FETCH_DECISION_TABLE_NAMES_START, fetchDecisionTableNames);
}

// Root Saga for Fee Configuration Query
export function* DecisionTableConfigQuerySaga() {
    yield takeLatest(FETCH_DECISION_TABLE_CONFIG_START, fetchDecisionTableConfig);
}

// Root Saga for Fee Configuration Save
export function* DecisionTableConfigSaveSaga() {
    yield takeLatest(SAVE_DECISION_TABLE_CONFIG_START, saveDecisionTableConfig);
}

// Root Saga for Fee Configuration Create
export function* DecisionTableConfigCreateSaga() {
    yield takeLatest(CREATE_DECISION_TABLE_CONFIG_START, createDecisionTableConfig);
}

// Root Saga for Fee Configuration Delete
export function* DecisionTableConfigDeleteSaga() {
    yield takeLatest(DELETE_DECISION_TABLE_CONFIG_START, deleteDecisionTableConfig);
}

// Combined Fee Configuration Sagas
export default function* DecisionTableConfigSagas() {
    yield all([
        decisionTableNamesSaga(),
        DecisionTableConfigQuerySaga(),
        DecisionTableConfigSaveSaga(),
        DecisionTableConfigCreateSaga(),
        DecisionTableConfigDeleteSaga()
    ]);
}
